/**
 * Analog "event clock": a 12-hour dial with the start→end span painted as a
 * wedge, so a visitor sees at a glance when the event runs. Renders into any
 * element carrying data-clock, data-start and data-end (ISO strings with the
 * store's timezone offset). New nodes (e.g. event cards cloned by the events
 * page script) are picked up automatically via a MutationObserver.
 */
(function () {
  var NS = 'http://www.w3.org/2000/svg';

  function el(name, attrs, parent) {
    var n = document.createElementNS(NS, name);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(n);
    return n;
  }

  function point(cx, cy, r, deg) {
    var rad = ((deg - 90) * Math.PI) / 180;
    return [cx + r * Math.cos(rad), cy + r * Math.sin(rad)];
  }

  // Wall-clock hours/minutes from the ISO string's own offset (not the viewer's zone).
  function localParts(iso) {
    var m = /T(\d{2}):(\d{2})/.exec(iso || '');
    return m ? { h: +m[1], m: +m[2] } : null;
  }

  function render(node) {
    if (node.dataset.clockDone) return;
    var start = localParts(node.dataset.start);
    var end = localParts(node.dataset.end);
    if (!start) return;
    if (!end) end = { h: (start.h + 2) % 24, m: start.m }; // theme default: 2h event

    var size = 64, cx = 32, cy = 32, r = 29;
    var svg = el('svg', { viewBox: '0 0 64 64', width: size, height: size, class: 'art-clock__svg', 'aria-hidden': 'true' });
    el('circle', { cx: cx, cy: cy, r: r, class: 'art-clock__face' }, svg);

    // start/end angles on a 12h dial; duration decides the sweep (cap at a full turn)
    var a0 = ((start.h % 12) + start.m / 60) * 30;
    var mins = (end.h * 60 + end.m) - (start.h * 60 + start.m);
    if (mins <= 0) mins += 24 * 60;
    var sweep = Math.min(mins / 2, 360); // 720 min = 360°
    if (sweep >= 360) {
      el('circle', { cx: cx, cy: cy, r: r, class: 'art-clock__span' }, svg);
    } else {
      var p0 = point(cx, cy, r, a0), p1 = point(cx, cy, r, a0 + sweep);
      el('path', {
        d: 'M' + cx + ' ' + cy + ' L' + p0[0] + ' ' + p0[1] + ' A' + r + ' ' + r + ' 0 ' + (sweep > 180 ? 1 : 0) + ' 1 ' + p1[0] + ' ' + p1[1] + ' Z',
        class: 'art-clock__span'
      }, svg);
    }

    for (var i = 0; i < 12; i++) {
      var big = i % 3 === 0;
      var o = point(cx, cy, r, i * 30), n = point(cx, cy, r - (big ? 5 : 3), i * 30);
      el('line', { x1: o[0], y1: o[1], x2: n[0], y2: n[1], class: 'art-clock__tick' + (big ? ' art-clock__tick--big' : '') }, svg);
    }

    // hands at the start time
    var hh = point(cx, cy, r * 0.5, a0), mh = point(cx, cy, r * 0.78, start.m * 6);
    el('line', { x1: cx, y1: cy, x2: hh[0], y2: hh[1], class: 'art-clock__hand art-clock__hand--h' }, svg);
    el('line', { x1: cx, y1: cy, x2: mh[0], y2: mh[1], class: 'art-clock__hand art-clock__hand--m' }, svg);
    el('circle', { cx: cx, cy: cy, r: 2, class: 'art-clock__pin' }, svg);

    node.innerHTML = '';
    node.appendChild(svg);
    node.dataset.clockDone = '1';
  }

  function scan(root) {
    (root || document).querySelectorAll('[data-clock]').forEach(render);
  }

  window.artClock = { render: render, scan: scan };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();

  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.matches && n.matches('[data-clock]')) render(n);
        else scan(n);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
